import { fromUnixTime } from 'date-fns';
import { DateRangePicker } from '@crazyegginc/hatch';

import { useFunnelEditorContext } from '../../funnel-editor-context';
import { useSelectedSite, useTimeZonedFunctions } from '/src/hooks';
import { TIMEZONES } from '/src/features/_global/constants';
import { DateRange } from '/src/components/date-time/DateRange';

export function DateRangeRow() {
  const { date, setDateRange } = useFunnelEditorContext();
  const { selectedSite } = useSelectedSite();
  const { startOfDay, subDays, endOfDay } = useTimeZonedFunctions();

  const analyticsEnabledAt = selectedSite?.webAnalyticsEnabledAt
    ? startOfDay(fromUnixTime(selectedSite.webAnalyticsEnabledAt))
    : null;
  const thirtyDaysAgo = startOfDay(subDays(new Date(), 30));

  const lowerBoundary = analyticsEnabledAt
    ? analyticsEnabledAt < thirtyDaysAgo
      ? analyticsEnabledAt
      : thirtyDaysAgo
    : thirtyDaysAgo;

  return (
    <div className="mb-2.5 flex justify-between items-center">
      <DateRange className="ml-1 text-header-3" dateRange={date} />
      <div className="mr-1">
        <DateRangePicker
          lowerBoundary={lowerBoundary}
          upperBoundary={endOfDay(new Date())}
          startDate={date?.start_date}
          endDate={date?.end_date}
          special={date?.special}
          setDateRange={setDateRange}
          setCommonDateRange={setDateRange}
          showCommonRanges={true}
          size="lg"
          timezone={TIMEZONES.UTC}
          showTimeZone={true}
        />
      </div>
    </div>
  );
}
